import { questionSchema } from "@/schema/console/assessments/create/Question";
import { z } from "zod";

export const subCategorySchema = z.object({
  id: z.string(),
  content: z.string(),
  isEdit: z.boolean(),
  questions: z
    .array(questionSchema)
    .min(1, "Please add at least one question."),
});

export type SubCategory = z.infer<typeof subCategorySchema>;
